import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';

@Injectable()
export class SearchService {
  constructor(private http: ApiClient) {}

  gloabalSearch(searchTerm) {
    return this.http.get<any>(`search/${encodeURIComponent(searchTerm)}`);
  }

  addressSearch(searchTerm, locationId: number) {
    return this.http.get<any>(
      `address-search?input=${encodeURIComponent(
        searchTerm
      )}&type=autocomplete&location_id=${locationId}`
    );
  }

  directions(placeId: string, locationId: number) {
    return this.http.get<{ distance: number; duration: number }>(
      `address-search?type=directions&input=${placeId}&location_id=${locationId}`
    );
  }

  getPlaceDetails(placeId: string) {
    return this.http.get<any>(
      `address-search?type=placeDetails&input=${placeId}`
    );
  }
}
